import { render, staticRenderFns } from "./GoogleSeoWidget.vue?vue&type=template&id=a938a02a&scoped=true&"
import script from "./GoogleSeoWidget.vue?vue&type=script&lang=js&"
export * from "./GoogleSeoWidget.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSeoWidget.vue?vue&type=style&index=0&id=a938a02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a938a02a",
  null
  
)

export default component.exports